module.exports = __webpack_public_path__ + "static/media/oakwood-homes-logo.120bc8a8.svg";